import { render } from "./ConsultDetail_DigitalTransformation.vue?vue&type=template&id=2a9b5c0c&scoped=true"
import script from "./ConsultDetail_DigitalTransformation.vue?vue&type=script&lang=js"
export * from "./ConsultDetail_DigitalTransformation.vue?vue&type=script&lang=js"

import "./ConsultDetail_DigitalTransformation.vue?vue&type=style&index=0&id=2a9b5c0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9b5c0c"]])

export default __exports__